import { cn } from '@src/design-system/helpers';

export const NotificationSection = ({
  title,
  children,
  className,
}: {
  title: string;
  children: React.ReactNode;
  className?: string;
}) => (
  <div className={cn(className)}>
    <p className='text-ms font-medium text-gray-500 uppercase mb-2'>{title}</p>
    <div className='space-y-2'>{children}</div>
  </div>
);
